module.exports = __webpack_public_path__ + "img/linkedin.c466d8db.svg";